// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2VJno","input":"styles_input__pkRHp"};